import React from 'react';
import { FiGithub, FiHeart, FiExternalLink } from 'react-icons/fi';
import './Footer.css';

/**
 * Footer component with credits and links
 */
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-info">
          <p className="footer-disclaimer">
            This site is not affiliated with Hypixel Inc. or Mojang Studios.
          </p>
          <p className="footer-credits">
            Made with <FiHeart className="heart-icon" /> using React & Node.js
          </p>
        </div>

        <div className="footer-links">
          <a
            href="https://hypixel.net"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Hypixel
            <FiExternalLink />
          </a>
          <a
            href="https://developer.hypixel.net"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            API Docs
            <FiExternalLink />
          </a>
          <a
            href="https://github.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            <FiGithub />
            GitHub
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
